import React, {Component, Fragment} from 'react';
import PropTypes from 'prop-types';
import Button from '@spothero/ui/button';
import SHLoader from 'common/loader/SHLoader';
import Icon from 'common/icon/Icon';
import DestinationInfoModalMobile from 'destination/DestinationInfoModalMobile';
import EventListItem from './EventListItem';
import WithEventList from './WithEventList';

class EventListMobile extends Component {
    static propTypes = {
        isLoading: PropTypes.bool,
        city: PropTypes.object.isRequired,
        destination: PropTypes.object,
        loadData: PropTypes.func.isRequired,
        onEventSelected: PropTypes.func.isRequired,
        onHide: PropTypes.func.isRequired
    };
    state = {
        showDestinationModal: false
    };

    componentDidMount() {
        this.props.loadData();
    }

    _onHideClick = evt => {
        this.props.onHide();
    }

    _onShowDestinationModal = evt => {
        this.setState({
            showDestinationModal: true
        });
    }

    _onHideDestinationModal = evt => {
        this.setState({
            showDestinationModal: false
        });
    }

    _onEventSelected = event => {
        this.props.onEventSelected(event);
    }

    render() {
        const {
            isLoading,
            destination,
            city
        } = this.props;
        const {
            showDestinationModal
        } = this.state;
        const {
            title,
            state,
            street_address: streetAddress,
            description,
            events
        } = destination;
        const {
            display_name: cityDisplayName,
            timezone
        } = city;

        return (
            <div className="EventListMobile">
                {(isLoading)
                    ? (
                        <div className="Loader-container">
                            <SHLoader
                                additionalMarkup={<p>Loading {title} events...</p>}
                            />
                        </div>
                    ) : (
                        <div className="EventListMobile-wrapper">
                            <div
                                className="EventListMobile-venue"
                                onClick={this._onShowDestinationModal}
                            >
                                <Icon name="info" />
                                <p>{title}<br />{cityDisplayName}, {state}</p>
                            </div>
                            {(events && events.length > 0)
                                ? (
                                    <Fragment>
                                        <h2 className="EventListMobile-title heading-sm">Upcoming Events</h2>
                                        <div className="EventListMobile-events">
                                            {events.map(event => {
                                                return (
                                                    <EventListItem
                                                        key={event.id}
                                                        event={event}
                                                        timezone={timezone}
                                                        destination={destination}
                                                        city={city}
                                                        onClick={this._onEventSelected}
                                                        isMobile
                                                    />
                                                );
                                            })}
                                        </div>
                                    </Fragment>
                                ) : (
                                    <p className="EventListMobile-no-results">No Results</p>
                                )
                            }
                            <Button
                                className="EventListMobile-not-event"
                                color="primary"
                                block
                                onClick={this._onHideClick}
                            >
                                Not looking for an event?
                            </Button>
                        </div>
                    )
                }
                {showDestinationModal &&
                    <DestinationInfoModalMobile
                        title={title}
                        address={streetAddress}
                        city={cityDisplayName}
                        state={state}
                        description={description}
                        onHidden={this._onHideDestinationModal}
                    />
                }
            </div>
        );
    }
}

export default WithEventList(EventListMobile);
